import { Link } from 'react-router-dom';
import Events from 'components/events';


const StandTitleField = ({ eeID, id, title, linkDisabled = false }) => {

    // Check if we're on graphics route in graphic-storage
    const isGraphicsRoute = window.location.pathname.includes('/graphic-storage/') &&
                            window.location.pathname.includes('/graphics');

    // Disable link if explicitly disabled or on graphics route
    const shouldDisableLink = linkDisabled || isGraphicsRoute;

    return (
        shouldDisableLink ? (
            <strong style={ { color: 'white' } }>
                { title }
            </strong>
        ) : (
            <Link to={ {
                pathname: `${ Events.Const.basePath }/${ eeID }/stands/${ id }`,
                state: {
                    breadcrumbSlug: {
                        id,
                        label: title
                    }
                }
            } }
            >
                { title }
            </Link>
        )
    );
};

export default StandTitleField;
